import * as types from '../mutation_types'
const state = {
  nickname: '工具人',
  avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
  id: '123'
}

const getters = {
  userInfo: (state) => {
    return {
      nickname: state.nickname || '未命名',
      avatar: state.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
      id: state.id
    }
  }
}

const actions = {
}

const mutations = {
  [types.SET_USER](state, userinfo) {
    state.nickname = userinfo.nickname
    state.avatar = userinfo.avatar
    state.id = userinfo.id
  },
  [types.UPDATE_USER](state, userinfo) {
    Object.assign(state, userinfo)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js